import { createHOC } from 'vue-hoc';

import ChoosePasswordForm from './ChoosePasswordForm';
import {
  authResultKey,
  groupsDataKey,
  activeGroupsDataKey,
  productTypeKey
} from '../../../../lib/common/providers/auth';
import userManagement from '../../../../lib/common/providers/userManagement';

const options = {
  name: 'ChoosePasswordFormContainer',
  data() {
    return {
      state: {
        decodedToken: null,
        loading: false,
        error: null,
      },
    };
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
  },
  listeners: {
    setError(value) {
      this.state.error = value;
    },
    async signup(user, token, decodedToken) {
      this.state.error = null;
      this.state.loading = true;
      try {
        const body = {
          password: user.password,
          token
        }
        const result = await userManagement.post('/integrations/add-user', body);
        if (result.status === 200) {
          // Set local storage
          const payload = result.data;
          localStorage.setItem(authResultKey,
            JSON.stringify({  fromSkeletonKey: true, idToken: payload.idToken, idTokenPayload: payload.idTokenPayload }));
          localStorage.setItem(groupsDataKey, JSON.stringify(payload.groupData.groups));
          localStorage.setItem(activeGroupsDataKey, JSON.stringify(payload.groupData.activeGroups));
          localStorage.setItem(productTypeKey, payload.idTokenPayload['https://vrpatients.com/productType']);

          // Go to scenario. Prefer the versioned launch URL minted at LTI launch
          // (falls back to the old-style targetUrl for tokens issued before versioning).
          window.location.replace(decodedToken.launchUrl || decodedToken.targetUrl)
        } else {
          this.state.error = { message: result.data.message || 'An error occurred during provisioning.' };
        }
      } catch (error) {
        this.state.error = { ...error, message: error.message || error.description };
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const ChoosePasswordFormContainer = createHOC(ChoosePasswordForm, options, renderWith);
export default ChoosePasswordFormContainer;
